import { processWorkflow } from './thunks';
import { guid7 } from '../containers/GlobalState';
import { buildWorkflow } from './buildWorkflow';

// Thunk: dispatch(exporting(save, flowId, preview)) returns the workflow id or false
export const exporting = (save, flowId, preview = false) => (dispatch, getState) => {
    try {
        const existingWorkflow = Object.values(getState().workflows).find(w => !w.simulatorPreview && w.studio?.id == flowId)
        console.log('EXPORTING', flowId, existingWorkflow)

        const newId = existingWorkflow ? undefined : guid7('FE')
        const workflow = buildWorkflow(save, flowId, preview, existingWorkflow, newId)

        dispatch(processWorkflow(workflow))

        return workflow.id

    } catch (error) {
        console.log('Export Error:', error)
        return false
    }
}

